const WORLD_CUP_FIXTURE = [
    [1, 'Mexico', 'Sudafrica', 'Jueves 11 de junio - 16:00'],
    [2, 'Corea del Sur', 'Republica Checa', 'Jueves 11 de junio - 23:00'],
    [3, 'Canada', 'Bosnia y Herzegovina', 'Viernes 12 de junio - 16:00'],
    [4, 'Estados Unidos', 'Paraguay', 'Viernes 12 de junio - 22:00'],
    [5, 'Haiti', 'Escocia', 'Sabado 13 de junio - 22:00'],
    [6, 'Australia', 'Turquia', 'Domingo 14 de junio - 01:00'],
    [7, 'Brasil', 'Marruecos', 'Sabado 13 de junio - 19:00'],
    [8, 'Qatar', 'Suiza', 'Sabado 13 de junio - 16:00'],
    [9, 'Costa de Marfil', 'Ecuador', 'Domingo 14 de junio - 20:00'],
    [10, 'Alemania', 'Curazao', 'Domingo 14 de junio - 14:00'],
    [11, 'Paises Bajos', 'Japon', 'Domingo 14 de junio - 17:00'],
    [12, 'Suecia', 'Tunez', 'Domingo 14 de junio - 23:00'],
    [13, 'Arabia Saudita', 'Uruguay', 'Lunes 15 de junio - 19:00'],
    [14, 'Espana', 'Cabo Verde', 'Lunes 15 de junio - 13:00'],
    [15, 'Iran', 'Nueva Zelanda', 'Lunes 15 de junio - 22:00'],
    [16, 'Belgica', 'Egipto', 'Lunes 15 de junio - 16:00'],
    [17, 'Francia', 'Senegal', 'Martes 16 de junio - 16:00'],
    [18, 'Irak', 'Noruega', 'Martes 16 de junio - 19:00'],
    [19, 'Argentina', 'Argelia', 'Martes 16 de junio - 22:00'],
    [20, 'Austria', 'Jordania', 'Miercoles 17 de junio - 01:00'],
    [21, 'Ghana', 'Panama', 'Miercoles 17 de junio - 20:00'],
    [22, 'Inglaterra', 'Croacia', 'Miercoles 17 de junio - 17:00'],
    [23, 'Portugal', 'RD Congo', 'Miercoles 17 de junio - 14:00'],
    [24, 'Uzbekistan', 'Colombia', 'Miercoles 17 de junio - 23:00'],
    [25, 'Republica Checa', 'Sudafrica', 'Jueves 18 de junio - 13:00'],
    [26, 'Suiza', 'Bosnia y Herzegovina', 'Jueves 18 de junio - 16:00'],
    [27, 'Canada', 'Qatar', 'Jueves 18 de junio - 19:00'],
    [28, 'Mexico', 'Corea del Sur', 'Jueves 18 de junio - 22:00'],
    [29, 'Brasil', 'Haiti', 'Viernes 19 de junio - 22:00'],
    [30, 'Escocia', 'Marruecos', 'Viernes 19 de junio - 19:00'],
    [31, 'Turquia', 'Paraguay', 'Sabado 20 de junio - 01:00'],
    [32, 'Estados Unidos', 'Australia', 'Viernes 19 de junio - 16:00'],
    [33, 'Alemania', 'Costa de Marfil', 'Sabado 20 de junio - 17:00'],
    [34, 'Ecuador', 'Curazao', 'Sabado 20 de junio - 21:00'],
    [35, 'Paises Bajos', 'Suecia', 'Sabado 20 de junio - 14:00'],
    [36, 'Tunez', 'Japon', 'Domingo 21 de junio - 01:00'],
    [37, 'Uruguay', 'Cabo Verde', 'Domingo 21 de junio - 19:00'],
    [38, 'Espana', 'Arabia Saudita', 'Domingo 21 de junio - 13:00'],
    [39, 'Belgica', 'Iran', 'Domingo 21 de junio - 16:00'],
    [40, 'Nueva Zelanda', 'Egipto', 'Domingo 21 de junio - 22:00'],
    [41, 'Noruega', 'Senegal', 'Lunes 22 de junio - 21:00'],
    [42, 'Francia', 'Irak', 'Lunes 22 de junio - 18:00'],
    [43, 'Argentina', 'Austria', 'Lunes 22 de junio - 14:00'],
    [44, 'Jordania', 'Argelia', 'Martes 23 de junio - 00:00'],
    [45, 'Inglaterra', 'Ghana', 'Martes 23 de junio - 17:00'],
    [46, 'Panama', 'Croacia', 'Martes 23 de junio - 20:00'],
    [47, 'Portugal', 'Uzbekistan', 'Martes 23 de junio - 14:00'],
    [48, 'Colombia', 'RD Congo', 'Martes 23 de junio - 23:00'],
    [49, 'Escocia', 'Brasil', 'Miercoles 24 de junio - 19:00'],
    [50, 'Marruecos', 'Haiti', 'Miercoles 24 de junio - 19:00'],
    [51, 'Suiza', 'Canada', 'Miercoles 24 de junio - 16:00'],
    [52, 'Bosnia y Herzegovina', 'Qatar', 'Miercoles 24 de junio - 16:00'],
    [53, 'Republica Checa', 'Mexico', 'Miercoles 24 de junio - 22:00'],
    [54, 'Sudafrica', 'Corea del Sur', 'Miercoles 24 de junio - 22:00'],
    [55, 'Curazao', 'Costa de Marfil', 'Jueves 25 de junio - 17:00'],
    [56, 'Ecuador', 'Alemania', 'Jueves 25 de junio - 17:00'],
    [57, 'Japon', 'Suecia', 'Jueves 25 de junio - 20:00'],
    [58, 'Tunez', 'Paises Bajos', 'Jueves 25 de junio - 20:00'],
    [59, 'Turquia', 'Estados Unidos', 'Jueves 25 de junio - 23:00'],
    [60, 'Paraguay', 'Australia', 'Jueves 25 de junio - 23:00'],
    [61, 'Noruega', 'Francia', 'Viernes 26 de junio - 16:00'],
    [62, 'Senegal', 'Irak', 'Viernes 26 de junio - 16:00'],
    [63, 'Egipto', 'Iran', 'Sabado 27 de junio - 00:00'],
    [64, 'Nueva Zelanda', 'Belgica', 'Sabado 27 de junio - 00:00'],
    [65, 'Cabo Verde', 'Arabia Saudita', 'Viernes 26 de junio - 21:00'],
    [66, 'Uruguay', 'Espana', 'Viernes 26 de junio - 21:00'],
    [67, 'Panama', 'Inglaterra', 'Sabado 27 de junio - 18:00'],
    [68, 'Croacia', 'Ghana', 'Sabado 27 de junio - 18:00'],
    [69, 'Argelia', 'Austria', 'Sabado 27 de junio - 23:00'],
    [70, 'Jordania', 'Argentina', 'Sabado 27 de junio - 23:00'],
    [71, 'Colombia', 'Portugal', 'Sabado 27 de junio - 20:30'],
    [72, 'RD Congo', 'Uzbekistan', 'Sabado 27 de junio - 20:30']
].map(([id, homeTeam, awayTeam, dateTime]) => ({
    id,
    homeTeam,
    awayTeam,
    dateTime,
    result: '',
    status: 'scheduled'
}));

export default WORLD_CUP_FIXTURE;
